import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON,
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import * as runtime from '@/api/runtime'
import {
  BatchStatisticsCollectionSelectItemResult,
  BatchStatisticsCollectionSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsCollectionSelectItemResult'
import {
  BatchStatisticsGetPredefinedSettingRequest,
  BatchStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingRequest'
import {
  BatchStatisticsCollectionRequest,
  BatchStatisticsCollectionRequestToJSON
} from '@/api/models/batch/BatchStatisticsCollectionRequest'

export class BatchStatisticsCollectionApi extends runtime.BaseAPI {
  /**
   * セレクト項目取得
   * @param request
   */
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsCollectionSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsCollectionSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 登録済み出力条件取得
   * @param request
   */
  async getPredefinedSetting(
    request: BatchStatisticsGetPredefinedSettingRequest
  ): Promise<BatchStatisticsCollectionSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsCollectionSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 検索状態登録
   * @param request
   */
  async registPattern(
    request: BatchStatisticsCollectionRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/statistics/regist_collection_item`,
      BatchStatisticsCollectionRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createCollection(
    request: BatchStatisticsCollectionRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/collection`,
      BatchStatisticsCollectionRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
